import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/logo.png";
import {
    login,
    changePassword
} from "../services/authService";

function Login() {
const navigate = useNavigate();

const [showPassword, setShowPassword] = useState(false);

const [showCurrentPassword, setShowCurrentPassword] = useState(false);

const [showNewPassword, setShowNewPassword] = useState(false);

const [showConfirmPassword, setShowConfirmPassword] = useState(false);

const [username, setUsername] = useState("");
const [password, setPassword] = useState("");

const [isLoading, setIsLoading] = useState(false); // ✅ prevent double click

const [showChangePassword, setShowChangePassword] = useState(false);

const [changePasswordData, setChangePasswordData] = useState({
    username: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
});

const handleChangePassword = async () => {

    // VALIDATION
    if (
        !changePasswordData.currentPassword ||
        !changePasswordData.newPassword ||
        !changePasswordData.confirmPassword
    ) {
        alert("All fields required");
        return;
    }

    // PASSWORD MATCH
    if (
        changePasswordData.newPassword !==
        changePasswordData.confirmPassword
    ) {
        alert("New password and confirm password mismatch");
        return;
    }

    try {

        const result = await changePassword({

            username: changePasswordData.username,

            currentPassword:
                changePasswordData.currentPassword,

            newPassword:
                changePasswordData.newPassword
        });

        alert(result);

        setShowChangePassword(false);

    } catch (err) {

        alert(
            err?.response?.data ||
            "Password update failed"
        );
    }
};

const handleLogin = async () => {

    // 🔴 VALIDATION
    if (!username.trim() || !password.trim()) {
        alert("Username and Password required");
        return;
    }

    if (isLoading) return; // ✅ prevent double click

    setIsLoading(true);

    try {
        const user = await login(username, password);

        localStorage.setItem("user", JSON.stringify(user));

        navigate("/app/home");

    } catch (err) {
        alert(err || "Invalid username or password");
    } finally {
        setIsLoading(false); // ✅ always release
    }
};

return (
    <div style={styles.container}>

        <div style={styles.card}>

            <img src={logo} alt="Logo" style={styles.logo} />

            <h2 style={styles.title}>CRM Enterprises Pvt Ltd</h2>
            <h2 style={styles.subtitle}>Sales Tracking System</h2>

            <div style={styles.formGroup}>

                <input
                    type="text"
                    placeholder="Username"
                    style={styles.input}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />

                <div style={styles.passwordWrapper}>
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        style={styles.input}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <span
                        style={styles.eyeIcon}
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? "🙈" : "👁"}
                    </span>
                </div>

                <div style={styles.linkRow}>

                    <span
                        style={styles.linkText}
                        onClick={() =>
                            alert("Please contact administrator to reset password")
                        }
                    >
                        Forgot Password?
                    </span>

                    <span
                        style={styles.linkText}
                        onClick={() => {

                            setChangePasswordData({
                                username,
                                currentPassword: "",
                                newPassword: "",
                                confirmPassword: ""
                            });

                            setShowChangePassword(true);
                        }}
                    >
                        Change Password
                    </span>

                </div>
                <button
                    type="button"   // 🔥 ADD THIS LINE
                    style={styles.button}
                    onClick={handleLogin}
                    disabled={isLoading}
                >
                    {isLoading ? "Logging in..." : "Login"}
                </button>

            </div>

        </div>
        {
            showChangePassword && (

                <div style={styles.modalOverlay}>

                    <div style={styles.modal}>

                        <h3 style={{
                            marginBottom: "15px",
                            fontFamily: "Verdana"
                        }}>
                            Change Password
                        </h3>

                        <input
                            type="text"
                            placeholder="Username"
                            value={changePasswordData.username}
                            readOnly
                            style={styles.input}
                        />

                        <div style={styles.passwordWrapper}>

                            <input
                                type={showCurrentPassword ? "text" : "password"}
                                placeholder="Current Password"
                                value={changePasswordData.currentPassword}
                                onChange={(e) =>
                                    setChangePasswordData(prev => ({
                                        ...prev,
                                        currentPassword: e.target.value
                                    }))
                                }
                                style={styles.input}
                            />

                            <span
                                style={styles.eyeIcon}
                                onClick={() =>
                                    setShowCurrentPassword(!showCurrentPassword)
                                }
                            >
                                {showCurrentPassword ? "🙈" : "👁"}
                            </span>

                        </div>

                        <div style={styles.passwordWrapper}>

                            <input
                                type={showNewPassword ? "text" : "password"}
                                placeholder="New Password"
                                value={changePasswordData.newPassword}
                                onChange={(e) =>
                                    setChangePasswordData(prev => ({
                                        ...prev,
                                        newPassword: e.target.value
                                    }))
                                }
                                style={styles.input}
                            />

                            <span
                                style={styles.eyeIcon}
                                onClick={() =>
                                    setShowNewPassword(!showNewPassword)
                                }
                            >
                                {showNewPassword ? "🙈" : "👁"}
                            </span>

                        </div>

                        <div style={styles.passwordWrapper}>

                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm Password"
                                value={changePasswordData.confirmPassword}
                                onChange={(e) =>
                                    setChangePasswordData(prev => ({
                                        ...prev,
                                        confirmPassword: e.target.value
                                    }))
                                }
                                style={styles.input}
                            />

                            <span
                                style={styles.eyeIcon}
                                onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                }
                            >
                                {showConfirmPassword ? "🙈" : "👁"}
                            </span>

                        </div>

                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: "10px"
                        }}>

                            <button
                                style={styles.button}
                                onClick={handleChangePassword}
                            >
                                Update
                            </button>

                            <button
                                style={{
                                    ...styles.button,
                                    background: "#6c757d",
                                    border: "1px solid #6c757d"
                                }}
                                onClick={() =>
                                    setShowChangePassword(false)
                                }
                            >
                                Cancel
                            </button>

                        </div>

                    </div>

                </div>
            )
        }
    </div>
);
}

const styles = {
    container: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #74b9ff, #0984e3)"
    },

card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    width: "330px",
    textAlign: "center",
    boxShadow: "0 5px 15px rgba(0,0,0,0.2)"
},

logo: {
    width: "80px",
    marginBottom: "1px"
},

title: {
    marginBottom: "1px",
    fontWeight: "600"
},

subtitle: {
    fontSize: "16px",
    color: "#6c5ce7",
    fontWeight: "600",
    letterSpacing: "0.5px",
    marginBottom: "15px"
},

formGroup: {
    width: "90%",
    margin: "0 auto"
},

input: {
    width: "100%",
    padding: "12px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    boxSizing: "border-box"
},

passwordWrapper: {
    position: "relative"
},

eyeIcon: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer"
},
linkRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12px",
    fontSize: "12px",
    fontFamily: "Verdana"
},

linkText: {
    color: "#0984e3",
    cursor: "pointer",
    textDecoration: "underline"
},
modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
},

modal: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    width: "350px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)"
},
button: {
    width: "100%",
    padding: "12px",
    background: "#0984e3",
    color: "#fff",
    border: "1px solid #0984e3",
    borderRadius: "6px",
    cursor: "pointer",
    boxSizing: "border-box"
}
};

export default Login;
